"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { recordHistoryTraversal, recordIfListingPath, recordPathChange } from "./nav-history";

// Mounted once in the /resources layout so it survives client-side
// navigations between listing and article pages, recording each listing
// page visited so ArticleHeader's back link can return to the right one,
// and each back/forward traversal so a listing can restore where it was left.
export function ResourcesNavTracker() {
  const pathname = usePathname();

  useEffect(() => {
    recordIfListingPath(pathname);
    recordPathChange(pathname);
  }, [pathname]);

  useEffect(() => {
    window.addEventListener("popstate", recordHistoryTraversal);
    return () => window.removeEventListener("popstate", recordHistoryTraversal);
  }, []);

  return null;
}
